<template>
    <div class="card_main">
        <div class="card_title">
            卡券
            <div @click="back" class="card_back">
                <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
            </div>
        </div>
        <div class="content">
            <div class="card_nav">
                <div @click="getCurrentIndex(index)" v-for="(item , index) in navList"  :key="index" :class="[currentIndex == index ? 'activer' : '','nav_item']">
                    {{item}}
                </div>
            </div>
            <template v-if="currentIndex === 0" >
                <div  class="roll_list" :style="'width: 100%;'+'height:'+height+'px'+';overflow-y:auto;'">
                 <div v-if="dataList.length>0" >
                <!-- <div v-if="dataList.length>0"> -->
                    <div class="roll_item" v-for="(item , index) in dataList" :key="index">
                        <div class="roll_left">
                            <div style="font-size:16px;margin-bottom:15px;">{{item.name}}</div>
                            <div class="roll_explam">{{item.explain}}</div>
                            <div style="font-size:14px;">{{formatDate(item.startTime)}}-{{formatDate(item.endTime)}}到期</div>
                        </div>
                        <div class="roll_right">
                            <div class="roll_top">
                                <span class="roll_unit">￥</span>
                                <span class="roll_price">{{item.creditAmount}}</span>
                            </div>
                            <!-- $router.push({name:'learn',params:{index:1,name:'course'}}) -->
                            <div @click="viewBiz(item)" class="hand roll_bottom">
                                去使用
                            </div>

                        </div>
                    </div>
                </div>

                <div v-else class="noList_style" :style="'width: 100%;'+'height:'+height+'px'">
                   <img src="icon/userIcon/nodata_icon.png" alt="">
                </div>
                </div>
            </template>

            <template  v-if="currentIndex === 1">
                 <div  class="roll_list" :style="'width: 100%;'+'height:'+height+'px'+';overflow-y:auto;'">
                <div v-if="dataList.length>0">
                    <div class="roll_item" v-for="(item , index) in dataList" :key="index">
                        <div class="roll_left" style="opacity:.5">
                            <div style="font-size:16px;margin-bottom:15px;">{{item.name}}</div>
                            <div class="roll_explam">{{item.explain}}</div>
                            <div style="font-size:14px;">{{formatDate(item.startTime)}}-{{formatDate(item.endTime)}}到期</div>
                        </div>
                        <div class="roll_right" style="opacity:.5">
                            <div class="roll_top">
                                <span class="roll_unit">￥</span>
                                <span class="roll_price">{{item.creditAmount}}</span>
                            </div>
                            <div class="roll_bottom">
                                已过期
                            </div>

                        </div>
                    </div>
                </div>
                <div v-else class="noList_style" :style="'width: 100%;'+'height:'+height+'px'">
                   <img src="icon/userIcon/nodata_icon.png" alt="">
                </div>
                 </div>
            </template>


        </div>

        <!-- <div class="conversion_btn">
            兑换优惠券
        </div> -->

    </div>
</template>
<script>
// style
import '@comp/coupon/cardroll.scss';

// config
import appConfig from '../../appConfig';

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// util
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';
import {toOrderDetail} from '@comp/shixunApp/toDetail';

const config = {
    apiConfig : {
        list : {
            url : '/portal/v2/coupon/my',
            params:{
               isExpire:false
            },
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};


export default {
    name: "cardroll",
    extends : shixunPagePart,

    data(){
        return{
            height:0,

            currentIndex:0,
            navList:['可用券','无效券'],
            scrollControl:{
                viewContainer:".roll_list",
                scrollContainer:".roll_list"
            },
            enableDataList : true,
            autoLoadDataList : true,
            scrollToLoadNextPage:50,
            // scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,
            //  pageSize : 20,
            title:'卡券',

            toOrderDetail:toOrderDetail,


        }
    },
    created(){

    },
    methods:{
        back(){
             appHelper.back(this);
        },
        viewBiz(item) {

            if (item.scope != 2)    // 不是特定商品
            {
                appHelper.goToPage('vodCourseList');
                return;
            }

            toOrderDetail(item.orderBizType, item.bizId);
        },
        getCurrentIndex(index){
            this.currentIndex = index
            if(index === 0){
                 this.apiConfig.list.params.isExpire = false
                 this.reloadDataList();
            }else if(index === 1){
                 this.apiConfig.list.params.isExpire = true
                 this.reloadDataList();
            }

        },

        formatDate(timer){
            let time = new Date(timer)
            let year = time.getFullYear()
            let month = time.getMonth() + 1
            let day = time.getDate()

            if(year<10){

                year = '0'+year
            }

            if(month<10){
               month =  '0'+month
            }
            if(day<10){
                day = '0'+day
            }
            return year+'.'+month+'.'+day

        },

        setWechatShare : function()
        {
            let wechatShareOptions = {
                title   : appHelper.getTitle(),
                desc    : this.desc,
                link    : location.href,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);
        }


    },
    mounted(){
        appHelper.setTitle(this.title);

        if (deviceHelper.isBrowser && browserHelper.isWechat)
        {
            this.setWechatShare();
        }

         let h = document.documentElement.clientHeight || document.body.clientHeight;
        this.height = h - 98;


    }
}
</script>
<style lang="scss" scoped>
.roll_explam{
    font-size:14px;
    padding-right:4px;
    letter-spacing: 1px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

}

.noList_style{
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 261px;
        height: 210px;
    }
}

.roll_top{
    width: 100%;
    text-align: center;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50% , -50%);
}

.roll_bottom{
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translate(-50% , -50%);


    width: 76px;
    height: 24px;
    border: 1px solid #fff;
    border-radius: 14px;
    text-align: center;
    line-height: 24px;


    font-size: 12px;

    font-weight: 400;
    color: #FFFFFF;

}

</style>
